/* ReportCenterSectionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./ReportCenterSectionRenderer");

class ReportCenterSectionComponent extends EventEmitter {
    constructor(di, utils, logger, sectionRouter, router, userSession) {
        super();
        this._di = di;
        this._steveUtils = utils;
        this._logger = logger;

        this._sectionRouter = sectionRouter;
        this._router = router;
        this._userSession = userSession;

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    get di() {
        return this._di;
    }
    shutdown() {
        this._unregisterListeners();
        let promArr = [this._renderer.shutdown()];
        return Promise.all(promArr).then(
            () => {
                this._renderer = undefined;
                this._di = undefined;
                this._steveUtils = undefined;
                this._logger = undefined;
                this._sectionRouter = undefined;
                this._router = undefined;
                this._userSession = undefined;
            },
            (err) => {
                this._logger.warn({error: err}, "ReportCenterSectionComponent.shutdown() error.");
            }
        );
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = ReportCenterSectionComponent;
ReportCenterSectionComponent.$inject = [
    "$teve.di",
    "$teve.utils",
    "$teve.logger",
    "$teve.sectionRouter",
    "$teve.router",
    "$teve.userSession",
];
